import type { AppState } from '../domain/types'

/** Stable coaching context for a future server-side AI adapter. Never place API keys here. */
export const athleteContext = {
  version: 1,
  timeZone: 'America/Mexico_City',
  background: {
    experience: 'Avanzado; fuerza, anillas, carrera e HYROX.',
    recentWeightRangeKg: [73, 76],
    estimatedHeightRangeCm: [182, 185],
  },
  priorities: [
    'Estética de torso: pecho superior, deltoide lateral/posterior, dorsales, espalda alta y brazos.',
    'Recuperar Ring Muscle-Up hasta 4 × 5 limpio y después añadir 1–2.5 kg.',
    'Abdominales hipertrofiados tres veces por semana.',
    'Mantener piernas fuertes y desarrollar capacidad HYROX sin interferencia excesiva.',
  ],
  coachingRules: [
    'Usar progresión objetiva y ejercicios estables; no confundir fatiga con progreso.',
    'Compuestos normalmente a 1–2 RIR; aislamientos a 0–1 RIR si la técnica se mantiene.',
    'No reintroducir Iron Cross o Maltese ni convertir el plan en powerlifting puro.',
    'Proteína de 150–170 g suele ser suficiente; no exigir 200+ g automáticamente.',
    'Responder de forma directa, cuantificada y accionable, sin párrafos genéricos.',
  ],
  currentProgram: 'Ultra Aesthetic + Ring Muscle-Up · 12 semanas',
} as const

export function buildAssistantSnapshot(state: AppState) {
  return {
    athlete: athleteContext,
    liveProfile: state.profile,
    measurements: state.measurements.map(({ photo: _photo, ...measurement }) => measurement),
    dietCheckIns: state.dietCheckIns,
    templates: state.templates,
    sessions: state.sessions,
  }
}
